<template lang="pug">
	.dropdown-menu.dropdown-menu-right.download-dropdown(v-show="showed" :style="position" v-pseudo-modal="'download-dropdown'" :class="{'multiple-download': multipleDownloadAllowed}")
		.dropdown-header
			strong Download creative
			.debug-download(v-if="User?.currentUser?.isAdmin && ['playable', 'end-card'].includes(Creative?.SelectedCreative?.type)" v-b-tooltip.hover="{title: 'Readable JavaScript'}" :class="{checked: debugCode}" @click.stop="debugCode = !debugCode")
				i.fa.fa-bug
				.debug-checkbox
					i.fa.fa-check(v-show="debugCode")
			span.multiple-download-switch(v-if="isShowMultipleDownload()" v-b-tooltip.hover="{title: 'Enable multiple download'}")
				.switch-control
					label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
						input.switch-input.form-check-input(type="checkbox" v-model="multipleDownloadAllowed" @change.stop="User.toggleFeature(User.currentUser.id, 'multipleDownload', multipleDownloadAllowed)")
						span.switch-slider(data-checked="On" data-unchecked="Off")
						span.switch-handle
		.tests-header(v-if="User?.currentUser?.isAdmin && Creative?.SelectedCreative?.type === 'playable'" :class="Testing.getLastMraidSDKStatus() ? 'success-tests' : 'failed-tests'")
			.success-tests
				div This version has passed all internal tests.
			.failed-tests
				p It looks like this version of creative didn't pass all internal tests.
				p Please go through the creative to the end card and click on the CTA button to find out for sure whether the tests pass.
				button.btn.btn-sm.btn-outline-danger(v-on:click="openTests") Look at the failed tests
		NetworkList(ref="NetworkList" :callback="downloadCreative" scope="download" :multipleAllowed="multipleDownloadAllowed")
		.multiple-download-button-wrapper
			button.btn.btn-sm.btn-outline-success.multiple-download-button(v-if="multipleDownloadAllowed" v-on:click="downloadCreativesMultiple" :class="{'disabled': User.currentUser && User.currentUser.options.features && Object.keys(User.currentUser.options.features.multipleDownloadNetworks || {}).length < 1}" v-b-tooltip.hover="{delay: {show: 500, hide: 100}, title: ''}") Download {{getSelectedReleasesCount()}} builds
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Creative } 			from '../../services/Creative'
	import { User }				from '../../services/User'
	import { Server } 			from "../../services/Server"
	import { Version } 			from "../../services/Version"

	import NetworkList 			from './../Templates/NetworksList'

	export default {
		name: "DownloadDropdown",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Multiple Download Networks Changed",
				"Current User Changed: [options.features]",
				"Selected Version Changed: [options.tests]"
			],
			events: {
				"Show DownloadDropdown": function(el, element) {

					this.element = element;

					this.debugCode = false;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.top = (rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного download-dropdown - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'download-dropdown') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Creative = Creative;
			this.User = User;

			return {
				position: {
					right: 0,
					top: 0
				},
				multipleDownloadAllowed: false,
				debugCode: false
			};

		},
		methods: {
			collectData() {

				if (Creative.SelectedCreative?.type === 'storyboard') return;

				this.multipleDownloadAllowed = User.currentUser?.options?.features?.multipleDownload && this.isShowMultipleDownload();

				if (this.$refs["NetworkList"]) this.$refs["NetworkList"].update();

			},
			downloadCreative(type) {

				if (Monitoring.activeProcesses['release-build'][`${Version.SelectedVersion.id}-${type}`]) return;

				if (type === 'sky-kids') {

					Broadcast.call("Show UploadSkyKids", ["download-mode", {debugCode: this.debugCode}]);

				} else {

					Creative.downloadCreative(type, undefined, {debugCode: this.debugCode});

				}

				Broadcast.call("Download Creative Started");

			},
			downloadCreativesMultiple() {

				if (User.currentUser && User.currentUser.options && User.currentUser.options.features) {

					let networks = Object.keys(User.currentUser.options?.features?.multipleDownloadNetworks || {}).filter(release => Settings.isReleaseAvailable(release, this.multipleDownloadAllowed, 'download'));
					if (networks.length < 1) return;

					Server.sendToSocket({
						DownloadCreativeMultiple: {
							creativeId: Creative.SelectedCreative.id,
							versionId: Version.SelectedVersion.id,
							releasesTypes: networks,
							debugCode: this.debugCode
						}
					});

					networks.forEach(network => {
						Monitoring.setProcess({type: "release-build", name: `${Version.SelectedVersion.id}-${network}`})
					});

				}
			},
			isShowMultipleDownload() {

				if (Creative.SelectedCreative?.type !== 'playable' && Creative.SelectedCreative?.type !== 'end-card') return false;

				let show = true;

				if (Publisher.SelectedPublisher?.options) {

					let releaseNames = Publisher.SelectedPublisher.options.ReleaseNames;

					if (releaseNames === 'version-names-only' || releaseNames === 'use-title') show = false;

				}

				return show;

			},
			getSelectedReleasesCount() {

				if (!this.multipleDownloadAllowed) return 0;

				if (!User.currentUser?.options?.features) return 0;

				let networks = Object.keys(User.currentUser.options?.features?.multipleDownloadNetworks || {}).filter(release => Settings.isReleaseAvailable(release, this.multipleDownloadAllowed, 'download'));

				return networks.length;

			},
			openTests() {

				if (Layout.asideOpened) {

					Layout.setSettingsTab('typical');

				} else {

					Layout.toggleAside('settings');
					Layout.setSettingsTab('typical');

				}

				this.close();

			},
			close() {

				if (this.$refs["NetworkList"]) this.$refs["NetworkList"].unsetSelectedGroup();

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.download-dropdown
		position: absolute
		z-index: 10000
		line-height: 1.5
		width: 300px !important
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		display: flex
		flex-direction: column
		overflow: visible !important

		.dropdown-header
			padding: 8px 20px !important
			cursor: default
			display: flex !important
			flex-direction: row
			justify-content: space-between
			align-items: center

			strong
				padding-left: 0

			.multiple-download-switch
				opacity: 0.3

			strong:only-child
				margin: 0 auto

		.debug-download
			margin-left: auto
			padding: 0 8px
			display: flex
			align-items: center
			cursor: pointer

			.fa-bug
				font-size: 13px
				color: #e4e7ea
				margin-right: 5px
				opacity: 0.5

			.debug-checkbox
				width: 16px
				height: 16px
				background-color: #23282c
				border: 1px solid #454f57
				border-radius: 3px
				display: flex
				align-items: center
				justify-content: center

				.fa-check
					font-size: 11px
					color: var(--green)

			&.checked

				.fa-bug
					opacity: 1

				.debug-checkbox
					border-color: var(--green)

		.tests-header
			padding: 8px 20px
			cursor: default
			display: flex
			flex-direction: column
			font-size: 0.765625rem
			color: #e4e7ea
			align-items: start

			&.success-tests
				border: 1px solid var(--success)
				color: var(--success)

				.failed-tests
					display: none

			&.failed-tests
				border: 1px solid var(--danger)
				color: var(--danger)

				.success-tests
					display: none

		.networks
			//height: 550px

		.multiple-download-button-wrapper
			display: none
			position: relative
			background-color: #353b41
			border-top: 1px solid #23282c
			height: 55px
			justify-content: center
			cursor: none
			pointer-events: none

			button
				margin-top: 10px
				margin-bottom: 10px
				opacity: 0
				padding: 0 20px

		&.multiple-download

			.multiple-download-switch
				opacity: 1

			.multiple-download-button-wrapper
				display: flex

				button
					opacity: 1
					pointer-events: auto
					cursor: pointer

					&.disabled
						opacity: 0.3
						cursor: not-allowed

	.download-dropdown::-webkit-scrollbar
		display: none

	.download-dropdown
		scrollbar-width: none
		-ms-overflow-style: none


</style>

